import { useContext, useLayoutEffect, useState } from "react";
import CustomizerContext from "../../../../../../_helper/Customizer";
import {
  Description,
  Status,
  Name,
  Alias,
  PayHeadline,
  Taxable,
  Pensionable,
  PayCategory,
} from "../../../../../../Constant";

import { toast } from "react-toastify";
import useAuth from "../../../../../../Hooks/useAuth";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import { PayrollPayCategoryApi, PayrollPayHeadlineApi } from "../../../../../../api";
import { createDropdownField } from "../../../../../../Data/FormField/PublicData";

export default function usePayrollPayHeadlineForm() {
  const axiosPrivate = useAxiosPrivate();
  const formTitle = PayHeadline;
  const { userOrganisationId }: any = useAuth();
  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "name",
      name: "name",
      label: Name,
      type: "text",
      value: "",
      required: true,
      colSize: 6,
    },

    {
      id: "short_name",
      name: "short_name",
      label: Alias,
      type: "text",
      value: "",
      required: true,
      colSize: 6,
    },

    {
      id: "description",
      name: "description",
      label: Description,
      type: "textarea",
      value: "",
      required: true,
      colSize: 6,
    },
    {
      id: "is_taxable",
      name: "is_taxable",
      label: Taxable,
      type: "switch",
      value: "1",
      colSize: 6,
    },
    {
      id: "is_pensionable",
      name: "is_pensionable",
      label: Pensionable,
      type: "switch",
      value: "1",
      colSize: 6,
    },
    {
      id: "is_active",
      name: "is_active",
      label: Status,
      type: "switch",
      value: "1",
      colSize: 6,
    },
  ]);

  const PayCategoryDropDown = createDropdownField(
      axiosPrivate,
      "payroll_pay_category_id",
      "payroll_pay_category_id",
      PayCategory,
      `${PayrollPayCategoryApi}?organisation_id=${userOrganisationId}`,
      "",
      6
  );

  // ?? Call on every dependent change
  async function updateFields() {
      const updatedFields = [PayCategoryDropDown, ...formFields];
      await PayCategoryDropDown.fetchOptions();
      setFormFields(updatedFields);
  }

  // ?? Call on every dependent change
  useLayoutEffect(() => {
    //?? Updates all fields once component is mounted
    updateFields();
  }, []);


  const { layoutURL } = useContext(CustomizerContext);
  const backBtn = `${process.env.PUBLIC_URL}/payroll/settings/pay-headlines/${layoutURL}`;

  const onSubmit = async (data: any) => {
    data.organisation_id = userOrganisationId;
    // console.log(data);
    await axiosPrivate
      .post(PayrollPayHeadlineApi, data)
      .then((_res) => {
        toast.success(`${_res.data.data.name} Created Successfully.`);
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          toast.error("Validation Errors");
        } else if (err.response && err.response.status === 400) {
          toast.error(err.response.data.detail);
        } else {
          toast.error("Whoops! Something went wrong");
        }
        throw err;
        //toast.error(err.response.message || "Whoops! Something went wrong");
      });
  };

  return { formTitle, formFields, backBtn, onSubmit };
}
